import { NgModule } from '@angular/core';

import { SharedModule }                  from '../shared/shared.module';
import { VehicleVisualsPlayerComponent } from './vehicle-visuals.player.component';
import { VehicleVisualsService }         from './vehicle-visuals.service';

@NgModule({
  declarations: [
    VehicleVisualsPlayerComponent
  ],
  entryComponents: [
    VehicleVisualsPlayerComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    VehicleVisualsService
  ]
})
export class VehicleVisualsModule {}
